import * as styles from './styles';

import type { Checklist } from '@cobliteam/api-lib';

import type { ITableColumn } from '@cobliteam/base-components';

export const ChecklistNameColumn = (): ITableColumn<Checklist> => ({
  id: 'name',
  label: 'Checklist',
  sortable: true,
  orderByKey: (row) => row.name,

  Cell: (row) => <div className={styles.checklistName}>{row.name}</div>,
});

export default ChecklistNameColumn;
